
export const formatConcurrency = (value) => {
  const result = Number(value).toFixed(1).replace(/\d(?=(\d{3})+\.)/g, '$&,').split('.')[0]
  return result + 'đ'
}